import { useState } from 'react';
import FeedbackForm from './FeedbackForm';
import { Button, Drawer } from 'antd';
import { MessageCircle } from 'lucide-react';
const FeedBack = () => {
  const [openFeedback, setOpenFeedback] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const handleDrawerClose = () => {
    setOpenFeedback(false);
    setFormKey((prev) => prev + 1);
  };
  return (
    <>
      <Button
        icon={<MessageCircle size={20} />}
        onClick={() => setOpenFeedback(true)}
        type="primary"
      >
        {' '}
        Give Feedback
      </Button>
      <Drawer
        size="large"
        title="Feedback Form"
        onClose={handleDrawerClose}
        open={openFeedback}
      >
        <FeedbackForm key={formKey} handleDrawerClose={handleDrawerClose} />
      </Drawer>
    </>
  );
};

export default FeedBack;
